import style from './IconServicesAvatar.module.css';
import { FaUserPen } from 'react-icons/fa6';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';

import { RxEnvelopeClosed } from 'react-icons/rx';
import { FiGift, FiUsers } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  selectIsAdmin,
  selectIsManager,
  selectUserType,
} from '../../../redux/auth/selectors';
import { HiMiniUserGroup } from 'react-icons/hi2';
import { Tooltip } from 'antd';

import { useEffect, useMemo, useState } from 'react';
import { updateFreeUser } from '../../../api/freeUsers';
import { updatePaidUser } from '../../../api/paidUsers.js';
import { fetchAgencyUserById } from '../../../api/agencyUsers';
import { checkOnlineStatus } from '../../../helpers/checkOnlineStatus';
import { selectOnlineUsers } from '../../../redux/websocket/selector';

const IconServicesAvatar = ({ user }) => {
  const navigate = useNavigate();
  const userType = useSelector(selectUserType);
  const isPaidUser = user?.typeAccount === 'paidUser';
  const onlineList = useSelector(selectOnlineUsers);
  const [agency, setAgency] = useState({ name: 'User Agency' });
  const userId = user?._id;
  const isAdmin = useSelector(selectIsAdmin);
  const isManager = useSelector(selectIsManager);
  const [isOnline, setIsOnline] = useState(user?.isOnline);
  const [isLoading, setIsLoading] = useState(false); // State to manage loading state
  const onlineColor = useMemo(() => {
    return checkOnlineStatus(user, onlineList);
  }, [user, onlineList]);

  const onlineStatus = onlineColor !== 'white';

  useEffect(() => {
    // if ((isAdmin || isManager) && user?.agencyID) {
    //   fetchAgencyUserById(user?.agencyID)
    //     .then(setAgency)
    //     .catch(() => {});
    // }
  }, [user, isAdmin, isManager]);

  const handleOnlineClick = async () => {
    if (!isAdmin && !isManager) {
      return;
    }
    if (onlineColor === 'green') return;
    try {
      const updatedData = { isOnline: !isOnline }; // Toggle the value
      console.log('Payload being sent:', updatedData); // Debug log
      let updatedUser;

      setIsLoading(true); // Start loading state
      if (user?.typeAccount === 'freeUser') {
        updatedUser = await updateFreeUser(userId, updatedData); // Call the API
      } else {
        updatedUser = await updatePaidUser(updatedData, userId);
      }

      setIsOnline(updatedUser.isOnline); // Update local state based on server response
    } catch (error) {
      console.error('Error updating user online status:', error);
    } finally {
      setIsLoading(false); // End loading state
    }
  };

  const handleLetterClick = () => {
    if (userType === 'paidUser') {
      navigate(`/man-user/letters/new-letter?userId=${user._id}`);
    } else {
      navigate(`/free-user/letters/new-letter?userId=${user._id}`);
    }
  };

  const handleMatchRedirect = () => {
    if (userType === 'paidUser') {
      navigate(`/man-user/matches?userId=${user._id}`);
    } else {
      navigate(`/free-user/matches?userId=${user._id}`);
    }
  };
  const handleGiftRedirect = () => {
    navigate(`/man-user/gifts-list?userId=${user._id}`);
  };

  const handleChatClick = () => {
    if (userType === 'paidUser') {
      navigate(`/man-user/live-chat?userId=${user._id}`);
    } else {
      navigate(`/free-user/live-chat?userId=${user._id}`);
    }
  };

  const handleEditProfileClick = () => {
    window.scrollTo({
      top: 300,
      behavior: 'smooth', // This makes the scroll smooth
    });

    if (userType === 'agencyUser') {
      navigate(`/agency-user/create-new-user?userId=${user._id}`);
    } else {
      navigate(`/man-user/edit-profile`); //TODO paid user is not open. Edit paid User is another component
    }
  };

  if (userType === 'agencyUser') {
    return (
      <div className={style.iconServicesContainer}>
        {(isAdmin || isManager) && (
          <div
            className={style.bgIconContainer}
            onClick={handleOnlineClick}
            style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }} // Disable pointer when loading
          >
            <Tooltip
              placement="top"
              title={
                onlineColor !== 'white' ? 'User is Online' : 'User is Offline'
              } // Tooltip text based on state
            >
              <HiOutlineChatBubbleLeftRight
                className={style.iconChatOnlineNow}
                style={{
                  color: onlineColor,
                  opacity: isLoading ? 0.5 : 1, // Dim the icon during loading
                }}
              />
            </Tooltip>
          </div>
        )}

        {!isPaidUser && (
          <div
            className={style.bgIconContainer}
            onClick={handleEditProfileClick}
          >
            <Tooltip placement="top" title="Edit User Profile">
              <FaUserPen className={style.editUser} />
            </Tooltip>
          </div>
        )}
        {!isPaidUser && (isAdmin || isManager) && (
          <div className={style.bgIconContainer}>
            <Tooltip placement="top" title={agency?.name}>
              <HiMiniUserGroup className={style.agencyUser} />
            </Tooltip>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className={style.iconServicesContainer}>
      {onlineStatus && (
        <div className={style.bgIconContainer}>
          <HiOutlineChatBubbleLeftRight
            className={style.iconChatOnlineNow}
            onClick={handleChatClick}
          />
        </div>
      )}
      {/* <div className={style.bgIconContainer}>
        <IoIosVideocam className={style.iconVideoCam} />
      </div> */}
      <div className={style.bgIconContainer}>
        <RxEnvelopeClosed
          className={style.iconEnvelope}
          onClick={handleLetterClick}
        />
      </div>

      {user?.typeAccount === 'freeUser' && (
        <div className={style.bgIconContainer} onClick={handleGiftRedirect}>
          <FiGift className={style.iconGift} />
        </div>
      )}
      <div className={style.bgIconContainer}>
        <FiUsers className={style.iconMatch} onClick={handleMatchRedirect} />
      </div>
    </div>
  );
};

export default IconServicesAvatar;
